<template>
  <div class="NewsDetails">
    <!-- 视差背景横幅 -->
    <div class="parallax-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1 class="animate__animated animate__fadeInDown">{{ newsIdList.title }}</h1>
        <p class="animate__animated animate__fadeInUp">NEWS DETAILS</p>
      </div>
    </div>

    <div class="news-section">
      <div class="news-section-content">
        <div class="news-header">
          <h1>{{ newsIdList.title }}</h1>
          <div class="news-meta">
            <span><i class="el-icon-time"></i>{{ formatCreateTime(newsIdList.createTime) }}</span>
          </div>
          <div class="news-image">
            <img :src="newsIdList.filePath" alt="News Image">
          </div>
          <div class="action-buttons">
            <el-button type="primary" class="contact-btn" @click="contactNow">
              <i class="el-icon-phone-outline"></i>免费回电
            </el-button>
            <el-button type="success" class="contact-btn" @click="showCompanyInfo">
              <i class="el-icon-message"></i>立即联系
            </el-button>
          </div>
        </div>

        <div class="news-content" v-html="newsIdList.content"></div>
      </div>
    </div>

    <div class="related-news">
      <div class="section-header">
        <h3>相关推荐</h3>
        <div class="header-line"></div>
      </div>
      <div class="news-grid">
        <div class="news-card" v-for="(obj, index) in caseList" :key="index" @click="routeLink(obj)">
          <div class="card-image" :style="{ backgroundImage: `url(${obj.filePath})` }"></div>
          <div class="card-content">
            <h4>{{ obj.title }}</h4>
          </div>
        </div>
      </div>
    </div>

    <ContactUs ref="contactUs"></ContactUs>
    <CompanyInfo ref="companyInfo"></CompanyInfo>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import ContactUs from "../components/ContactUs.vue";
import CompanyInfo from "../components/CompanyInfo.vue";
export default {
  name: "NewsDetails",
  components: {
    Banner,
    ContactUs,
    CompanyInfo
  },
  data() {
    return {
      item: {},
      newsIdList: {},
      caseList:[]
    };
  },
  created() {
    this.item = this.$route.params.item;
    if(this.item==undefined){
      this.item=JSON.parse(this.$route.query.item)
    }
    this.newsIdList=this.item
    // 这里可以添加根据获取到的item信息进一步请求详细数据的逻辑，比如：
    // this.fetchFullNewsDetails(this.item.id);
  },
  mounted() {
    this.loadData();
    this.isIos();
  },
  methods: {
    contactNow(){
      this.$refs.contactUs.showDialogVisible()
    },
    formatCreateTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    }, 
    scrollDown() {
      // 向下滚动 100 像素
      window.scrollBy({
        top: 1000, // 向下滚动的像素值
        behavior: 'smooth' // 平滑滚动
      });
    },
    routeLink(row) {
      this.$router.replace({ 
          name: "newsdetails", 
          query: { item: JSON.stringify(row) }
      });
      this.$router.go(0)
      this.loadData(); // 重新加载数据
    },
    isIos() {
      if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
        console.log("当前设备是手机");
      }
    },
    loadData() {
      // 这里假设你从路由参数中获取到的item已经包含了完整的新闻详情数据
      this.$http
        .get(`news/GetNewsAll?current=1&size=3`)
        .then((response) => {
          this.caseList = response.data.data.records;
          for (let a of this.caseList) {
            a.filePath = this.imgserver + a.filePath;
          }
          this.loading = false;
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
    showCompanyInfo() {
      this.$refs.companyInfo.showDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  background: #fff;

  // 视差背景横幅
  .parallax-banner {
    height: 40vh;
    background: url('../assets/img/bgtop.jpg') center/cover fixed;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }

    .banner-content {
      position: relative;
      z-index: 1;
      padding: 0 20px;

      h1 {
        font-size: 2.8rem;
        margin-bottom: 1rem;
        font-weight: 600;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
      }

      p {
        font-size: 1.2rem;
        letter-spacing: 0.2rem;
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .news-section {
    margin-top: -40px;
    padding: 0 20px;
    position: relative;
    z-index: 2;

    &-content {
      max-width: 1200px;
      margin: 0 auto;
      background: white;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      overflow: hidden;
      padding: 40px;

      .news-header {
        margin-bottom: 30px;
        text-align: center;

        h1 {
          font-size: 2rem;
          color: #2c3e50;
          margin-bottom: 15px;
          font-weight: 600;
        }

        .news-meta {
          color: #95a5a6;
          font-size: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;

          i {
            margin-right: 5px;
          }
        }

        .news-image {
          margin: 30px auto;
          width: 100%;
          max-width: 800px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
          background: white;
          padding: 20px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            max-height: 400px;
            object-fit: contain;
            border-radius: 8px;
            transition: transform 0.6s ease;
          }

          &:hover img {
            transform: scale(1.02);
          }
        }

        .action-buttons {
          margin-top: 30px;
          display: flex;
          gap: 20px;
          justify-content: center;

          .contact-btn {
            padding: 12px 30px;
            font-size: 1rem;
            border-radius: 25px;
            transition: all 0.3s ease;
            min-width: 160px;

            i {
              margin-right: 8px;
            }

            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            }
          }
        }
      }

      .news-content {
        white-space: pre-wrap;
        margin-top: 40px;
        padding: 30px;
        background: #f8f9fa;
        border-radius: 12px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

        :deep(p) {
          margin-bottom: 15px;
          line-height: 1.8;
          color: #495057;
        }

        :deep(img) {
          max-width: 100%;
          height: auto;
          border-radius: 8px;
          margin: 15px 0;
        }

        :deep(h1, h2, h3, h4, h5, h6) {
          color: #2c3e50;
          margin: 20px 0 10px;
        }

        :deep(ul, ol) {
          padding-left: 20px;
          margin-bottom: 15px;
        }

        :deep(.ql-size-small) {
          font-size: 0.85em;
        }
        
        :deep(.ql-size-large) {
          font-size: 1.25em;
        }
        
        :deep(.ql-size-huge) {
          font-size: 1.5em;
        }
      }
    }
  }

  .related-news {
    padding: 40px 20px;
    background: #f8f9fa;

    .section-header {
      text-align: center;
      margin-bottom: 30px;
      position: relative;

      h3 {
        font-size: 1.8rem;
        color: #2c3e50;
        margin-bottom: 15px;
        font-weight: 600;
      }

      .header-line {
        width: 60px;
        height: 3px;
        background: #409EFF;
        margin: 0 auto;
      }
    }

    .news-grid {
      max-width: 1200px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;

      .news-card {
        background: white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);

          .card-image {
            transform: scale(1.05);
          }
        }

        .card-image {
          height: 200px;
          background-size: cover;
          background-position: center;
          transition: transform 0.6s ease;
        }

        .card-content {
          padding: 20px;

          h4 {
            font-size: 1.1rem;
            color: #2c3e50;
            margin-bottom: 10px;
            font-weight: 500;
            line-height: 1.4;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  .parallax-banner {
    height: 25vh!important;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .NewsDetails {
    .parallax-banner {

      .banner-content {
        h1 {
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
        }

        p {
          font-size: 0.8rem;
          letter-spacing: 0.1rem;
        }
      }
    }

    .news-section {
      margin-top: -15px;
      padding: 0 15px;

      &-content {
        padding: 20px;

        .news-header {
          h1 {
            font-size: 1.5rem;
          }

          .action-buttons {
            flex-direction: column;

            .contact-btn {
              width: 100%;
            }
          }
        }
      }
    }

    .related-news {
      padding: 30px 15px;

      .news-grid {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>
